import React from 'react';

import type { SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
  count: number;
}

export const PeopleIcon: React.FC<IProps> = ({ count, ...props }) => (
  <svg
    width="29"
    height="26"
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="13" width="16" height="16" rx="8" fill="#321D05" />

    <text
      x="21"
      y="9"
      textAnchor="middle"
      dominantBaseline="middle"
      fill="white"
      fontSize="10"
      fontWeight="bold"
    >
      {count}
    </text>
    <path
      d="M15 24C15 24 16 24 16 23C16 22 15 19 11 19C7 19 6 22 6 23C6 24 7 24 7 24H15ZM7.02235 23C7.01888 22.9996 7.01403 22.999 7.00815 22.998C7.00538 22.9975 7.00266 22.997 7.00001 22.9965C7.00146 22.7325 7.16687 21.9669 7.75926 21.2758C8.31334 20.6294 9.28269 20 11 20C12.7173 20 13.6867 20.6294 14.2407 21.2758C14.8331 21.9669 14.9985 22.7325 15 22.9965C14.9973 22.997 14.9946 22.9975 14.9919 22.998C14.986 22.999 14.9811 22.9996 14.9777 23H7.02235Z"
      fill="#6F767E"
    />
    <path
      d="M11 17C12.1046 17 13 16.1046 13 15C13 13.8954 12.1046 13 11 13C9.89543 13 9 13.8954 9 15C9 16.1046 9.89543 17 11 17ZM14 15C14 16.6569 12.6569 18 11 18C9.34315 18 8 16.6569 8 15C8 13.3431 9.34315 12 11 12C12.6569 12 14 13.3431 14 15Z"
      fill="#6F767E"
    />
    <path
      d="M6.93593 19.28C6.56813 19.1623 6.15954 19.0768 5.70628 19.0331C5.48195 19.0114 5.24668 19 5 19C1 19 0 22 0 23C0 23.6667 0.333333 24 1 24H5.21636C5.07556 23.7159 5 23.3791 5 23C5 21.9897 5.37724 20.958 6.08982 20.0962C6.33327 19.8017 6.61587 19.5271 6.93593 19.28ZM4.92004 20.0005C4.32256 20.9136 4 21.9547 4 23H1C1 22.7393 1.16424 21.97 1.75926 21.2758C2.30468 20.6395 3.25249 20.0197 4.92004 20.0005Z"
      fill="#6F767E"
    />
    <path
      d="M1.5 15.5C1.5 13.8431 2.84315 12.5 4.5 12.5C6.15685 12.5 7.5 13.8431 7.5 15.5C7.5 17.1569 6.15685 18.5 4.5 18.5C2.84315 18.5 1.5 17.1569 1.5 15.5ZM4.5 13.5C3.39543 13.5 2.5 14.3954 2.5 15.5C2.5 16.6046 3.39543 17.5 4.5 17.5C5.60457 17.5 6.5 16.6046 6.5 15.5C6.5 14.3954 5.60457 13.5 4.5 13.5Z"
      fill="#6F767E"
    />
  </svg>
);
